import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common'
import { Router,ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service'
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { BsDatepickerConfig, DatepickerConfig } from 'ngx-bootstrap/datepicker';
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service'
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';


@Component({
  selector: 'app-client-details',
  templateUrl: './client-details.component.html',
  styleUrls: ['./client-details.component.css']
})
export class ClientDetailsComponent implements OnInit {

  worksheetDetails=[];
  nameInitials;
  searchText;
  allclientappointment;
  allclientappointmentlength;
  clientUpcomingAppointment;
  clientPreviousAppointment;
  upcomingAppointment="None";
  previousAppointment="None";
  clientPhoneNumber;
  clientName;
  clientEmail;
  clientDetails=[];
  error=[];
  currentUser:User;
  username;
  branch;
role;
success;


loggedInUsername
loggedInUserBranch;
loggedInUserFullname;
loggedInUserId;


  constructor(private fb: FormBuilder,
    private router: Router,
    private modalService: NgbModal,
    private _location: Location,
    private actroute: ActivatedRoute,
    private _authenticationService: AuthenticationService,
    private _appointment: AppointmentService,
    private _http: HttpClient,
    public datepipe: DatePipe) { 
      
      this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
      if(this.currentUser){
        this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
        this.branch=this.currentUser.branch;
        this.role=this.currentUser.role;


        this.loggedInUsername=this.currentUser.userName;
        this.loggedInUserFullname= this.username;
        this.loggedInUserBranch= this.branch
        this.loggedInUserId=this.currentUser.userName;
    
        
    
       }}

       //4169515446
  ngOnInit(): void {
    
    this.actroute.paramMap.subscribe(params => {
      // This is never executed, for route is not recognized
      // let myArray=params.getAll('extra');
      const clientPID = params.get('extra')
      this.clientName = params.get('extra1')
      this.clientPhoneNumber = params.get('extra2');
      this.clientEmail = params.get('extra3');
      console.log(this.clientName);
      const fullName = this.clientName.split(' ');
      if(fullName.length>1){
    this.nameInitials= fullName.shift().charAt(0) + fullName.pop().charAt(0);
    console.log(this.nameInitials);
      }
      else{
        this.nameInitials= fullName.shift().charAt(0);
      }
      //this.branch = params.get('extra3');
      
      if (clientPID!="") {
        console.log(clientPID);
        this.getClientDetailsToView(clientPID, this.clientName, this.clientPhoneNumber);
        this.getClientAppointment(clientPID,this.clientName, this.clientPhoneNumber);
        this.clientUpcomingAppointmentByPID(clientPID,this.clientName,this.clientPhoneNumber);
        this.clientPreviousAppointmentByPID(clientPID,this.clientName,this.clientPhoneNumber);
      } else {
        //      this.viewMode=false;
      //  console.log('done');
      }
    });




/******************************************************************************** */
  var allappointment = document.getElementById("allappointment");
  allappointment.style.display = "block";

  var allappointmentview=document.getElementById('allappointmentview');
  allappointmentview.style.backgroundColor='#FFFFFF';
  allappointmentview.style.color="#444444";

  /******************************************************************************** */
  var notes= document.getElementById("notes");
  notes.style.display = "none";
  
  var notesview=document.getElementById('notesview');
  notesview.style.backgroundColor='#444444';
  notesview.style.color="#FFFFFF";
  

  /******************************************************************************** */
  
  
  document.getElementById ("allappointmentview").addEventListener ("click", AllAppointmentFunction, false);
  document.getElementById ("notesview").addEventListener ("click", NotesFunction, false);

  }//End of NugOnInit


  openAppointment(list){
    //console.log(list.pid);
    ;
   {
   
    this.router.navigate(['../appointment-details', { extra: list.pid, extra1: list.fullName,extra2:list.phoneNumber,extra3:list.branch,extra4:list.timeIn }], { relativeTo: this.actroute });
    }
  }


  clientUpcomingAppointmentByPID(clientPID: string, clientName: any, clientPhoneNumber: any) {
    //console.log(clientPID);
    this._appointment.getClientUpcomingAppointment(clientPID, clientName, clientPhoneNumber).subscribe(
      response =>  {
        this.clientUpcomingAppointment= response;
        try {
         // this.allclientappointmentlength=this.allclientappointment.length;
          //console.log(this.allclientappointmentlength);
          this.upcomingAppointment=this.datepipe.transform(this.clientUpcomingAppointment[0]['timeIn'], 'MMM d, y h:mm a ');
     if(this.upcomingAppointment=="" || this.upcomingAppointment==null){
       this.upcomingAppointment="None";
     }
        
        } catch (error) {
          //console.log(error);
        }
        
       
      },
      (err) => {
        this.error = err;
      }
    );
  }
/********************************************************************************************************************* */
  clientPreviousAppointmentByPID(clientPID: string, clientName: any, clientPhoneNumber: any) {
    //console.log(clientPID);
    this._appointment.getClientPreviousAppointment(clientPID, clientName, clientPhoneNumber).subscribe(
      response =>  {
        this.clientPreviousAppointment= response;
        try {
       
        this.previousAppointment=this.datepipe.transform(this.clientPreviousAppointment[0]['timeIn'], 'MMM d, y h:mm a ');
        if(this.previousAppointment=="" || this.previousAppointment==null){
          this.previousAppointment="None";
        }
        } catch (error) {
          //console.log(error);
        }
        
       
      },
      (err) => {
        this.error = err;
      }
    );
  }

/********************************************************************************************************************* */
  getClientAppointment(clientID: string, clientName: any, clientPhoneNumber: any) {
    this._appointment.getAllClientAppointmentByPID(clientID,clientName,clientPhoneNumber).subscribe(
      (res) => {
        this.allclientappointment= res[0];
         //console.log(this.allclientappointment);
      },
      (err) => {
        this.error = err;
      }
    );
  }

/********************************************************************************************************************* */
  getClientDetailsToView(clientPID: string, clientName: string, clientPhoneNumber: string) {
    console.log(clientPID);
    this._appointment.getClientDetails(clientPID, clientName, clientPhoneNumber).subscribe(
      response =>  {
        this.clientDetails= response;
        console.log(this.clientDetails);
      },
      (err) => {
        this.error = err;
      }
    );
  
  }
  /********************************************************* */

checkbarScan(date){

  var actualdatetime=new Date(date);
  var currentdatetime=new Date();
  var  daterange=new Date(actualdatetime.setMinutes(actualdatetime.getMinutes() + 60));
//console.log(currentdatetime);
if(currentdatetime<=daterange){
  return true;
} else 
{
  return false;
} 
}
/********************************************************* */

  refresh(): void {
    window.location.reload();
  }
  
  isAdmin() {
    return this.currentUser && this.currentUser.role === UserRole.Administrator;
  }
  
  isSystemAdmin() {
    return this.currentUser && this.currentUser.role === UserRole.SystemAdministrator;
  }
  
  isReceptionist() {
    return this.currentUser && this.currentUser.role === UserRole.Receptionist;
  }
  
  isSalesRep() {
    return this.currentUser && this.currentUser.role === UserRole.SalesRepresentative;
  }
  
  isPowerUser() {
    return this.currentUser && this.currentUser.role === UserRole.PowerUser;
  }
  
  isSalesSupport() {
    return this.currentUser && this.currentUser.role === UserRole.SalesSupport;
  }
  
  
  
  createAppointment(client){
    console.log(client)
    this.router.navigate(['../create-appointment',{extra2:this.branch,extra3:client.pid,extra4:client.fullName,extra5:client.phoneNumber}],{relativeTo:this.actroute});
  }
editClient(client){

}
  deleteClient(client){

  }
  onAddWorksheet(test){

  }
/********************************************************************************************************************* */

  backClicked() {
    this._location.back();
  }
}



function AllAppointmentFunction() {
  var cal = document.getElementById("allappointment");
  cal.style.display = "block";

  var allappointmentview=document.getElementById('allappointmentview');
  allappointmentview.style.backgroundColor='#FFFFFF';
  allappointmentview.style.color="#444444";

  /****************************************************** */
  var notesview=document.getElementById('notesview');
  notesview.style.backgroundColor='#444444';
  notesview.style.color="#FFFFFF";
  

  var table = document.getElementById("notes");
  table.style.display = "none";
 
/****************************************************** */


  
}


function NotesFunction() {
  var table = document.getElementById("notes");
  table.style.display = "block";

  /*********************************************************** */
  var cal = document.getElementById("allappointment");
  cal.style.display = "none";

  var allappointmentview=document.getElementById('allappointmentview');
  allappointmentview.style.backgroundColor='#444444';
  allappointmentview.style.color="#FFFFFF";
  
   
/****************************************************** */
  var notesview=document.getElementById('notesview');
  notesview.style.backgroundColor='#FFFFFF';
  notesview.style.color="#444444";
  
 

}


